import { classNames, localeMoment } from "../../helpers";
import SessionModel from "../../api/models/SessionModel";
import { ClockIcon, CalendarIcon } from "@heroicons/react/solid";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { getSessionState } from "./helper";
import NoteInfoTable from "./NoteInfoTable";
import { useState } from "react";
import NoteModel from "../../api/models/NoteModel";
import { isValidMoment } from "../../helpers/date_helpers";
type SessionInfoProps = {
  session: SessionModel;
};
export default function StudentSessionInfo({ session }: SessionInfoProps) {
  const LocalBasePath = "page.student.dashboard.sessionInfo";
  const { t } = useTranslation();
  const [showNotes, setShowNotes] =
    useState<null | "passed" | "unpassed">(null);

  const getNotesByState = (state: string | null, notes: NoteModel[]) => {
    if (!!state && session.notes!.length > 0) {
      return session.notes?.filter((note) => note.status === state);
    } else {
      return notes;
    }
  };

  const sessionEndDate = () => {
    if (!isValidMoment(session.end_time) && session.isInProgress) {
      return t(`${LocalBasePath}.now`);
    } else if (isValidMoment(session.end_time)) {
      return session.end_time?.format("hh:mm A");
    }
    return "";
  };
  return (
    <div
      className={classNames("bg-white")}
      data-cy="sessionInfo"
      data-cy-session-id={session.id}
    >
      <div className="relative  px-6 py-5  items-center space-x-3">
        <div className="flex-shrink-0 flex pb-2">
          {getSessionState(session.status!)}
        </div>
        <div className="flex-shrink-0 pt-2 lg:flex block items-center justify-between">
          <div className="">
            <div className="flex-shrink-0 pt-2 flex items-center justify-between ">
              <h1 className={classNames("font-bold text-2xl")}>
                {t(`${LocalBasePath}.session`)} #{session.sessionNumber}
              </h1>
            </div>
            <div className="flex-1 min-w-0">
              <div
                className={classNames(
                  "py-2 flex  items-center justify-between text-gray-400 "
                )}
              >
                <div className="  flex rounded-full items-center justify-between">
                  <CalendarIcon className="w-[18px]  rtl:ml-1 ltr:mr-1" />

                  {localeMoment(session!.date!).format("dddd L")}
                </div>
                {isValidMoment(session.start_time) && (
                  <div className=" p-1 px-2.5 flex rounded-full items-center justify-between">
                    <ClockIcon className="w-[18px] rtl:ml-1 ltr:mr-1" />
                    {session.start_time
                      ?.locale(i18next.language)
                      .format("hh:mm A")}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-3 items-center">
            <a
              target="_blank"
              href={session?.recordingUrl}
              className="inline-flex cursor-pointer items-center px-4 py-2   shadow-sm text-base font-medium rounded-md text-white bg-brandblue-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
            >
              {t(`${LocalBasePath}.showRedord`)}
            </a>
          </div>
        </div>

        <div className="columns-1  md:columns-2">
          <div className="pt-10">
            <h6 className="text-gray-500 text-sm	">
              {t(`${LocalBasePath}.sessionTime`)}
            </h6>
            {isValidMoment(session.start_time) && (
              <h6 className="text-gray-700 pt-1 text-lg">
                {session.start_time?.format("hh:mm A")}-{sessionEndDate()}
              </h6>
            )}
          </div>
          <div className="pt-10">
            <h6 className="text-gray-500">{t(`${LocalBasePath}.pagesRead`)}</h6>
            <h6 className="text-gray-700 pt-1 text-lg">
              <span>{`${session.startPageNumber || 0} - `}</span>
              <span>{session.endPageNumber || ""}</span>
            </h6>
          </div>
        </div>
        <div>
          {/* TODO: The following should be moved to it's own component something like StudentNotesTableActionsHeader */}
          {!!session.notes && session.notes.length > 0 && (
            <div className="columns-1  md:columns-2 mb-2  mt-10">
              <div className="pt-10">
                <h6 className="text-gray-500 text-sm	">
                  {t(`${LocalBasePath}.observationsMadeDuringTheSession`)}
                </h6>
              </div>
              <div className="pt-10">
                <div className="flex  justify-end  text-sm w-full">
                  <div className="flex items-center justify-between  w-[210px]">
                    <button
                      onClick={() => {
                        setShowNotes(null);
                      }}
                      className={classNames(
                        // showNotes != null && "text-brandblue-500",
                        "text-gray-500"
                      )}
                      data-cy="showAllNotes"
                    >
                      {t(`${LocalBasePath}.everyone`)}
                    </button>
                    <button
                      onClick={() => {
                        setShowNotes("unpassed");
                      }}
                      className={classNames(
                        (showNotes === null || showNotes === "unpassed") &&
                          "text-brandblue-500",
                        "text-gray-500"
                      )}
                      data-cy="showUnpassedNotes"
                    >
                      {t(`${LocalBasePath}.unpassed`)}
                    </button>
                    <button
                      onClick={() => {
                        setShowNotes("passed");
                      }}
                      className={classNames(
                        (showNotes === null || showNotes === "passed") &&
                          "text-brandblue-500",
                        "text-gray-500"
                      )}
                      data-cy="showPassedNotes"
                    >
                      {t(`${LocalBasePath}.passed`)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!!session.notes && session.notes.length > 0 && (
            <>
              <NoteInfoTable
                notes={getNotesByState(showNotes, session.notes)!}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
